import { render, staticRenderFns } from "./BuyInvoiceReport.vue?vue&type=template&id=4752b7b0&"
import script from "./BuyInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./BuyInvoiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports